import { OPEN_ALERT } from '../constants/index';
import { AlertState, AlertActions } from '../types/alertTypes'

const initialState: AlertState = {
  isOpen: false,
  message: '', 
  header: '',
  link: '',
  linkText: ''
}

const alertReducer = (state = initialState, action: AlertActions) => {
  const payload = action.payload
  switch(action.type){

    case OPEN_ALERT:
      return {
        ...state,
        isOpen: !state.isOpen,
        message: payload.message,
        header: payload.header,
        link: payload.link,
        linkText: payload.linkText
      }
    
    default: 
      return state
  }
}

export default alertReducer;